import { render, staticRenderFns } from "./KeLiKe.vue?vue&type=template&id=4c0c14de&scoped=true&"
import script from "./KeLiKe.vue?vue&type=script&lang=js&"
export * from "./KeLiKe.vue?vue&type=script&lang=js&"
import style0 from "./KeLiKe.vue?vue&type=style&index=0&id=4c0c14de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c14de",
  null
  
)

export default component.exports